import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/pages/Home.vue'
import Auth from '@/components/pages/Auth.vue'
import Estimations from '@/components/pages/Estimations.vue'
import Mandats from '@/components/pages/Mandats.vue'
import Agenda from '@/components/pages/Agenda.vue'
import Mail from '@/components/pages/Mail.vue'
import Clients from '@/components/pages/Clients.vue'
import Admin from '@/components/pages/Admin.vue'
import Archives from '@/components/pages/Archives.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/auth',
      name: 'Auth',
      component: Auth
    },
    {
      path: "/estim",
      name: "Estimations",
      component: Estimations
    },
    {
      path: "/mandats",
      name: "Mandats",
      component: Mandats
    },
    {
      path: "/mail",
      name: "Mail",
      component: Mail
    },
    {
      path: "/clients",
      name: "Clients",
      component: Clients
    },
    {
      path: "/agenda",
      name:"Agenda",
      component: Agenda
    },
    {
      path: "/admin",
      name:"Admin",
      component: Admin
    }, 
    {
      path: "/archives",
      name:"Archives",
      component: Archives
    }
  ]
})
